import { useRef, useEffect } from 'react';
import { QueryStatus } from '@reduxjs/toolkit/query';

import { parseAxiosError } from 'utils/error';

import { HandleMutationProps, BaseHandleMutationProps } from '../types';

import { useAlert } from './alert';

export const baseHandleMutation = ({
  error,
  reset,
  status,
  onError,
  onSuccess,
  showError,
}: BaseHandleMutationProps) => {
  const onSuccesRef = useRef(onSuccess);
  const onErrorRef = useRef(onError);
  const resetRet = useRef(reset);

  useEffect(() => {
    onSuccesRef.current = onSuccess;
  }, [onSuccess]);

  useEffect(() => {
    onErrorRef.current = onError;
  }, [onError]);

  useEffect(() => {
    resetRet.current = reset;
  }, [reset]);

  useEffect(() => {
    if (error) {
      if (onErrorRef.current) {
        onErrorRef.current(parseAxiosError(error), error);
      } else {
        showError(parseAxiosError(error));
      }
    }
  }, [error]);

  useEffect(() => {
    if (status === QueryStatus.fulfilled) {
      onSuccesRef.current?.();
      resetRet.current?.();
    }
  }, [status]);
};

export const handleMutation = (params: HandleMutationProps) => {
  const { showErrorAlert } = useAlert();

  baseHandleMutation({ ...params, showError: showErrorAlert });
};
